<span [ngClass]="getClassNames()">
  <mat-icon *ngIf="icon" inline>{{icon}}</mat-icon>
  {{ title }}
</span>
